// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
/**
 * Encodes commands to queue that can be executed later
 */
export class CommandEncoder extends Resource {
    static defaultProps = {
        ...Resource.defaultProps,
        measureExecutionTime: undefined
    };
    get [Symbol.toStringTag]() {
        return 'CommandEncoder';
    }
    constructor(device, props) {
        super(device, props, CommandEncoder.defaultProps);
    }
}
//# sourceMappingURL=command-encoder.js.map